import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Common from '../Common';
import Dialog from '../Dialog';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import $ from "jquery";

const MONTHS = [
    { key: 'm1', label: 'Apr' },
    { key: 'm2', label: 'May' },
    { key: 'm3', label: 'Jun' },
    { key: 'm4', label: 'Jul' },
    { key: 'm5', label: 'Aug' },
    { key: 'm6', label: 'Sep' },
    { key: 'm7', label: 'Oct' },
    { key: 'm8', label: 'Nov' },
    { key: 'm9', label: 'Dec' },
    { key: 'm10', label: 'Jan' },
    { key: 'm11', label: 'Feb' },
    { key: 'm12', label: 'Mar' }
];

function Master_Budget() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const defaultFinYear = (sessionStorage.getItem('finyear') || '').toString();

    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState({});
    const [finYear, setFinYear] = useState(defaultFinYear);
    const [rows, setRows] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    useEffect(() => {
        if (onceRun) {
            return;
        }

        Common.callApi(Common.apiRight, [sid, 'all', 'MASTER_FINANCIAL_PARAMETER'], function (result) {
            const resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/');
            }
        });
        setOnceRun(true);
    }, [onceRun, sid, navigate]);

    useEffect(() => {
        if (!onceRun) {
            return;
        }
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onceRun]);

    const loadData = () => {
        $(".loader").show();
        Common.callApi(Common.apiBudget, [sid, 'list'], function (result) {
            $(".loader").hide();
            const resp = JSON.parse(result);
            if (resp.status === 'MSG0002') {
                navigate('/');
                return;
            }
            if (resp.finyear) {
                setFinYear(resp.finyear);
            }
            setRows(resp.data || []);
        });
    };

    const saveData = () => {
        $(".loader").show();
        Common.callApi(Common.apiBudget, [sid, 'save', JSON.stringify(rows)], function (result) {
            $(".loader").hide();
            const resp = JSON.parse(result);
            if (resp.status === 'MSG0002') {
                navigate('/');
                return;
            }
            if (resp.err) {
                setMsgText(resp.err);
                setMsgBox(true);
                return;
            }
            if (resp.finyear) {
                setFinYear(resp.finyear);
            }
            setRows(resp.data || []);
            setMsgText('Budget saved successfully.');
            setMsgBox(true);
        });
    };

    const downloadFormat = () => {
        $(".loader").show();
        Common.callDownloadApiPost1(Common.apiBudget, "post", [sid, 'download'], function () {
            $(".loader").hide();
        });
    };

    const uploadBudget = () => {
        const fileInput = document.getElementById('importBudgetExcel');
        if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
            setMsgText('Please select a file to upload.');
            setMsgBox(true);
            return;
        }
        const file = fileInput.files[0];
        const fileParts = file.name.split('.');
        if (fileParts.length < 2 || fileParts[fileParts.length - 1].toLowerCase() !== 'xlsx') {
            setMsgText('File extension should be xlsx format.');
            setMsgBox(true);
            return;
        }

        $(".loader").show();
        const obj = {
            sid: sid,
            uploadType: "uploadBudget",
            pageright: "MASTER_FINANCIAL_PARAMETER"
        };
        Common.uploadApi(JSON.stringify(obj), 'importBudgetExcel', function (result) {
            $(".loader").hide();
            const resp = JSON.parse(result);
            if (resp.status) {
                setRows(resp.data || []);
                setMsgText(resp.msg || 'Budget uploaded successfully.');
            } else {
                setMsgText(resp.msg || 'Unable to upload budget.');
            }
            setMsgBox(true);
            fileInput.value = '';
        });
    };

    const updateAmount = (rowIndex, key, value) => {
        if (value !== '' && !/^\d*\.?\d{0,2}$/.test(value)) {
            return;
        }
        const next = [...rows];
        next[rowIndex] = { ...next[rowIndex], [key]: value };
        setRows(next);
    };

    const rowsWithTotal = useMemo(() => {
        return rows.map((row) => {
            let total = 0;
            MONTHS.forEach((m) => {
                total += (row[m.key] || 0) * 1;
            });
            return { ...row, total };
        });
    }, [rows]);

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col><h3>Master Branch Budget</h3></Col>
                </Row>
                <Row className='mb-2'>
                    <Col md={3} sm={6}>
                        <Form.Group>
                            <Form.Label>Financial Year</Form.Label>
                            <Form.Control type='text' value={finYear} readOnly />
                        </Form.Group>
                    </Col>
                    <Col className='d-flex align-items-end'>
                        <Button size='sm' className='buttonStyle' variant='outline-primary' onClick={loadData}>
                            Load
                        </Button>
                        &nbsp;
                        <Button size='sm' className='buttonStyle' variant='outline-primary' onClick={downloadFormat}>
                            Download Excel
                        </Button>
                        &nbsp;
                        {(userRight.add === "1" || userRight.edit === "1") ?
                            <Button size='sm' className='buttonStyle' variant='outline-success' onClick={saveData}>
                                Save
                            </Button> : null
                        }
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col md={4} sm={8}>
                        <Form.Group>
                            <Form.Label>Upload Excel</Form.Label>
                            <Form.Control id='importBudgetExcel' type='file' accept='.xlsx' />
                        </Form.Group>
                    </Col>
                    <Col className='d-flex align-items-end'>
                        {(userRight.add === "1" || userRight.edit === "1") ?
                            <Button size='sm' className='buttonStyle' variant='outline-success' onClick={uploadBudget}>
                                Upload Excel
                            </Button> : null
                        }
                    </Col>
                </Row>

                <Row>
                    <Col style={{ overflowX: 'auto' }}>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Branch</th>
                                    {MONTHS.map((m) => <th key={m.key}>{m.label}</th>)}
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rowsWithTotal.map((row, rowIndex) => (
                                    <tr key={row.branch_id}>
                                        <td>{row.branch_id} {row.branch_name}</td>
                                        {MONTHS.map((m) => (
                                            <td key={`${row.branch_id}_${m.key}`}>
                                                <Form.Control
                                                    type='text'
                                                    value={row[m.key] ?? ''}
                                                    onChange={(e) => updateAmount(rowIndex, m.key, e.target.value)}
                                                    disabled={!(userRight.add === "1" || userRight.edit === "1")}
                                                    autoComplete='off'
                                                />
                                            </td>
                                        ))}
                                        <td>{Common.formatNumberDisplay((row.total || 0).toFixed(2))}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={() => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </>
    );
}

export default Master_Budget;
